import { Card, CardHeader, CardTitle } from '@/components/ui/Card';
import type { ClientRecord } from '@/api/clients';

export function ClientBackgroundTab({ client: c }: { client: ClientRecord }) {
    return (
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-4">
            <Card className="lg:col-span-2">
                <CardHeader><CardTitle>Referral & Care Coordination</CardTitle></CardHeader>
                <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                    <LongTextBlock label="Reason for referral"          value={c.reasonForReferral}  className="md:col-span-2" />
                    <LongTextBlock label="Other services (OT, PT, SLP)" value={c.otherServices} />
                    <LongTextBlock label="Community services"           value={c.communityServices} />
                    <LongTextBlock label="Coordination of care"         value={c.coordinationOfCare} className="md:col-span-2" />
                </div>
            </Card>

            <Card>
                <CardHeader><CardTitle>Medical Background</CardTitle></CardHeader>
                <div className="flex flex-col gap-4">
                    <LongTextBlock label="Current medications"    value={c.medications} />
                    <LongTextBlock label="Allergies"              value={c.allergies} />
                    <LongTextBlock label="Family medical history" value={c.familyMedicalHistory} />
                </div>
            </Card>

            <Card>
                <CardHeader><CardTitle>School & Culture</CardTitle></CardHeader>
                <div className="flex flex-col gap-4">
                    <LongTextBlock label="Education"                       value={c.education} />
                    <LongTextBlock label="School schedule"                 value={c.schoolSchedule} />
                    <LongTextBlock label="Cultural / spiritual considerations" value={c.culturalConsiderations} />
                </div>
            </Card>
        </div>
    );
}

function LongTextBlock({
    label,
    value,
    className,
}: {
    label: string;
    value: string;
    className?: string;
}) {
    return (
        <div className={className}>
            <div className="text-2xs font-bold uppercase tracking-wider text-text-subtle mb-1">
                {label}
            </div>
            <p className="text-sm whitespace-pre-wrap">
                {value || <span className="text-text-subtle">—</span>}
            </p>
        </div>
    );
}
